module.exports = __webpack_public_path__ + "media/images/lb/616-2cbd0625145213b12e2f89d222df49a7.svg";